/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pilot_Ended_Contact_BodyInputs */



/**
* | output |
* | --- |
* | "Would you like to keep using Wundo, for yourself or for your team? Let us know." |
*
* @param {Pilot_Ended_Contact_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const pilot_ended_contact_body = /** @type {((inputs?: Pilot_Ended_Contact_BodyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pilot_Ended_Contact_BodyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Wil je Wundo blijven gebruiken, voor jezelf of voor je team? Laat het ons weten.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vous souhaitez continuer à utiliser Wundo, pour vous ou pour votre équipe ? Faites-le-nous savoir.")
	return /** @type {LocalizedString} */ ("Would you like to keep using Wundo, for yourself or for your team? Let us know.")
});